export default __webpack_public_path__ + "static/media/012-crime.252ad67a.svg";